import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import DatetimeRangePicker from 'react-datetime-range-picker';
import { connect } from 'react-redux';
import {
  setEndDateTime,
  setStartDateTime,
  setLast1Hour,
  setLast6Hours,
  setCustomTime,
  setMonitoringStartDateTime,
  setMonitoringEndDateTime,
  setTopologyStartDateTime,
  setTopologyEndDateTime,
  setMonitoringReloadTime,
  setTopologyReloadTime,
} from './reducer';
import classes from './DateTimeFilter.module.css';
import { Button } from '@cv/eds-react';
import { ListGroup, Overlay, Popover, Form } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const DateTimeFilter = (props) => {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const [selectedValue, setSelectedValue] = useState(''); // Default number input
  const [selectedUnit, setSelectedUnit] = useState("hour"); // Default unit selection
  const [activeFilter, setActiveFilter] = useState(""); // Tracks the active selection


  const {
    start,
    end,
    setStartDateTime,
    setEndDateTime,
    last1Hour,
    last6Hours,
    setLast1Hour,
    setLast6Hours,
    setCustomTime,
    topologyReloadTime,
    monitoringReloadTime,
    monitoringStart,
    monitoringend,
    topologyStart,
    topologyend,
    setTopologyReloadTime,
    setMonitoringReloadTime,
    setMonitoringStartDateTime,
    setMonitoringEndDateTime,
    setTopologyStartDateTime,
    setTopologyEndDateTime
  } = props;

  const location = useLocation();
  const [reloadTime, setReloadTime] = useState(600000);

  useEffect(() => {
    if (location.pathname === '/inventory' || location.pathname === '/changerequest' || location.pathname === '/incidents')
    {
      setReloadTime(600000)
    }
  }, [location]);

  //commenting this code to eliminate reload after 10 minutes
  useEffect(() => {
    // Reloads if not in Topology or Monitoring page
    if (location.pathname !== '/view/infra-topology' && location.pathname !== '/monitoring') {
      const timer = setInterval(() => {
        setStartDateTime(moment(start).add(10, 'minutes'));
        setEndDateTime(moment(end).add(10, 'minutes'));
      }, reloadTime);
      return () => {
        clearTimeout(timer);
      };
    } 
  }, [setStartDateTime, setEndDateTime, start, end]);

  useEffect(() => {
    // Reloads if in Topology page
    if (location.pathname === '/view/infra-topology' && topologyReloadTime > 0) {
      console.log('topologyReloadTimedatetime', topologyReloadTime);

      const timer1 = setInterval(() => {
        setTopologyStartDateTime(moment(topologyStart).add(topologyReloadTime, 'minutes'));
        setTopologyEndDateTime(moment(topologyend).add(topologyReloadTime, 'minutes'));
        setStartDateTime(moment(start).add(topologyReloadTime, 'minutes'));
        setEndDateTime(moment(end).add(topologyReloadTime, 'minutes'));
      }, (topologyReloadTime * 1000 * 60));
      return () => {
        clearTimeout(timer1);
      };
    }
  }, [topologyReloadTime, topologyStart, topologyend]);

  useEffect(() => {
    // Reloads if in Monitoring page
    if (location.pathname === '/monitoring' && monitoringReloadTime > 0) {
      console.log('monitoringReloadTime',monitoringReloadTime);
      
      const timer2 = setInterval(() => {
        setMonitoringStartDateTime(moment(monitoringStart).add(monitoringReloadTime, 'minutes'));
        setMonitoringEndDateTime(moment(monitoringend).add(monitoringReloadTime, 'minutes'));
        setStartDateTime(moment(start).add(monitoringReloadTime, 'minutes'));
        setEndDateTime(moment(end).add(monitoringReloadTime, 'minutes'));
      }, monitoringReloadTime * 1000 * 60);
      return () => {
        clearTimeout(timer2);
      };
    }
  }, [monitoringReloadTime, monitoringStart, monitoringend]);

  // useEffect(() => {
  //   if (last1Hour) {

  //       setMonitoringStartDateTime(moment(new Date()).subtract(1, 'hour'));
  //       setMonitoringEndDateTime(moment(new Date()));
    
  //       setTopologyStartDateTime(moment(new Date()).subtract(1, 'hour'));
  //       setTopologyEndDateTime(moment(new Date()));

  //       setStartDateTime(moment(new Date()).subtract(1, 'hour'));
  //       setEndDateTime(moment(new Date()));
      
  //   }
  //   if (last6Hours) {
     
  //       setMonitoringStartDateTime(moment(new Date()).subtract(6, 'hours'));
  //       setMonitoringEndDateTime(moment(new Date()));
    
  //       setTopologyStartDateTime(moment(new Date()).subtract(6, 'hours'));
  //       setTopologyEndDateTime(moment(new Date()));

  //       setStartDateTime(moment(new Date()).subtract(6, 'hours'));
  //       setEndDateTime(moment(new Date()));
  
  //   }
  // }, [last1Hour, last6Hours]);

  const handleChangeHandler = ({ start, end }) => {
    const timeDifference = moment(end).diff(moment(start), 'minutes');
    if (!(timeDifference === 60 || timeDifference === 360)) {
      setCustomTime();
    }
    setShow(false);
    setTarget(null);

    setMonitoringStartDateTime(start);
    setMonitoringEndDateTime(end);

    setTopologyStartDateTime(start);
    setTopologyEndDateTime(end);

    setStartDateTime(start);
    setEndDateTime(end);

  }

  const popover = (
    <Popover id={`popover-positioned`}>
      <Popover.Header as="h3" style={{ color: '#f2f2f2', background: '#181818' }}>
        Relative time selection
      </Popover.Header>
      <Popover.Body>
        <div>
        <Form.Group>
        <Form.Label style={{ color: 'grey'}}>Enter Time Duration</Form.Label>
        <Form.Control
          type="number"
          style={{ color: 'black', background: 'white' , border: '1px solid lightgrey'}}
          value={selectedValue}
          onChange={(e) => setSelectedValue(Number(e.target.value))}
        />
      </Form.Group>
        <Form.Group className="mb-3">
        <Form.Label style={{ color: 'grey'}}>Select Time Unit</Form.Label>
        <Form.Select value={selectedUnit} onChange={(e) => setSelectedUnit(e.target.value)}>
          <option value="hour">Hour(s)</option>
          <option value="day">Day(s)</option>
          {/* <option value="week">Week(s)</option>
          <option value="month">Month(s)</option> */}
        </Form.Select>
      </Form.Group>
      <Button style={{ color: '#ffffff', background: '#0069c2' }}onClick={() => handleApplyFilter()}>
        Apply Filter
      </Button>
      <Button style={{ color: '#000000', background: '#ffffff', border: '1px solid gray'}} onClick={() => handleClearFilter()}>
        Clear
      </Button>
          {/* <ListGroup as="ul">
            <ListGroup.Item as="button" onClick={() => setLast1Hour()} active={last1Hour}>
              Last 1 hour
            </ListGroup.Item>
             <ListGroup.Item
              as="button"
              onClick={() => setLast6Hours()}
              active={last6Hours}
            >
              Last 1 Day
            </ListGroup.Item>
            <ListGroup.Item
              as="button"
              onClick={() => setLast6Hours()}
              active={last6Hours}
            >
              Last 1 Week
            </ListGroup.Item>
            <ListGroup.Item
              as="button"
              onClick={() => setLast6Hours()}
              active={last6Hours}
            >
               Last 1 Month
            </ListGroup.Item>
          </ListGroup> */}
        </div>
      </Popover.Body>
    </Popover>
  );

  const handleClick = (event) => {   
    setShow(!show);
    setTarget(event.target);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        !ref.current.contains(event.target)
      ) {
        setShow(false);
      }
    };

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);


  const handleApplyFilter = () => {
    setActiveFilter(`${selectedValue} ${selectedUnit}`);
    console.log(activeFilter)
    setCustomTime();
  
    const newStartTime = moment(new Date()).subtract(selectedValue, selectedUnit);
    const newEndTime = moment(new Date());
  
    setMonitoringStartDateTime(newStartTime);
    setMonitoringEndDateTime(newEndTime);
    setTopologyStartDateTime(newStartTime);
    setTopologyEndDateTime(newEndTime);
    setStartDateTime(newStartTime);
    setEndDateTime(newEndTime);
  };

  const handleClearFilter = () => {
    setSelectedUnit("hour")
    setSelectedValue(" ")
    const newEndTime = moment();
  const newStartTime = moment().subtract(60, 'minutes');

  setMonitoringStartDateTime(newStartTime);
  setMonitoringEndDateTime(newEndTime);
  setTopologyStartDateTime(newStartTime);
  setTopologyEndDateTime(newEndTime);
  setStartDateTime(newStartTime);
  setEndDateTime(newEndTime);
  };

  return (
    <div className={classes.date_time_container}>
      <DatetimeRangePicker
        dateFormat={'DD/MM/YYYY'}
        onChange={handleChangeHandler}
        closeOnSelect
        className={classes.date_time +' dateTimeClass'}
        // startDate={start}
        // endDate={end}
        startDate={location.pathname === '/view/infra-topology'?topologyStart:location.pathname === '/monitoring'?monitoringStart:start}
        endDate={location.pathname === '/view/infra-topology'?topologyend:location.pathname === '/monitoring'?monitoringend:end}
        pickerClassName={`${classes.date_time_field}`}
      />
      {!location.pathname.includes('/performanceManagement') && <div ref={ref} >
        <Button onClick={handleClick} icon="calendar" />
        <Overlay show={show} target={target} placement="bottom" container={ref} >
          {popover}
        </Overlay>
      </div>}
    </div>
  );
};

const mapDispatchToProps = {
  setStartDateTime,
  setEndDateTime,
  setLast1Hour,
  setLast6Hours,
  setCustomTime,
  setTopologyReloadTime,
  setMonitoringReloadTime,
  setMonitoringStartDateTime,
  setMonitoringEndDateTime,
  setTopologyStartDateTime,
  setTopologyEndDateTime
};

const mapStateToProps = (state) => {
  console.log('state.dateTimeReducer.monitoringStart',state.dateTimeReducer.monitoringStart);
  console.log('state.dateTimeReducer.monitoringend', state.dateTimeReducer.monitoringend);
  
  console.log('state.dateTimeReducer.start',state.dateTimeReducer.start);
  
  return {
    start: state.dateTimeReducer.start,
    end: state.dateTimeReducer.end,
    last1Hour: state.dateTimeReducer.last1Hour,
    last6Hours: state.dateTimeReducer.last6Hours,
    topologyReloadTime: state.dateTimeReducer.topologyReloadTime,
    monitoringReloadTime: state.dateTimeReducer.monitoringReloadTime,
    topologyStart: state.dateTimeReducer.topologyStart,
    topologyend: state.dateTimeReducer.topologyend,
    monitoringStart: state.dateTimeReducer.monitoringStart,
    monitoringend: state.dateTimeReducer.monitoringend
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DateTimeFilter);
